import React from 'react';
import { FileUploader } from './FileUploader';
interface FileUploaderTypedProps {
    [key: string]: any; // Accept any props
}

const FileUploaderTyped: React.FC<FileUploaderTypedProps> = (props) => {
    return <FileUploader {...props} />;
};

export default FileUploaderTyped;
